import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MovingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"moving"}/>
}
